import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { ROUTES } from '../constants';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, loading, token } = useSelector((state: RootState) => state.auth);
  const location = useLocation();

  // Show loading while checking authentication
  if (loading) {
    return <div>Loading...</div>;
  }

  // Check both isAuthenticated flag and token presence
  const hasValidAuth = isAuthenticated && token;
  
  console.log('🔒 ProtectedRoute check:', { 
    isAuthenticated, 
    hasToken: !!token, 
    hasValidAuth,
    path: location.pathname 
  });

  // Redirect to login if not authenticated
  if (!hasValidAuth) {
    console.log('❌ Authentication failed, redirecting to login');
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  console.log('✅ Authentication verified, rendering protected content');
  return <>{children}</>;
};

export default ProtectedRoute;